module.exports = __webpack_public_path__ + "static/media/Pullman.6167baa8.mp4";